<template>
  <section>
    <div class="pop-room asset-detail-pop" v-if="assetChangeDetail.status">
      <h3 class="title">资产变更明细</h3>
      <a href="javascript:;" @click="hidePop()" class="iconfont icon-close"></a>
      <div class="pop-cont">

        <!-- 资产变更条目 -->
        <p style="padding: 10px 0 0;color: #d93c37;">已变更的资产列表</p>
        <el-table class="table-change-list" :data="assetChangeDetail.data.changeAssets" style="width: 100%">
          <el-table-column prop="number" label="资产编号" width="110px">
          </el-table-column>
          <el-table-column prop="name" label="资产名称">
          </el-table-column>
          <el-table-column prop="attribute.name" label="资产属性" width="90px">
          </el-table-column>
          <el-table-column prop="spec" label="规格型号" width="140px">
          </el-table-column>
          <el-table-column prop="price" label="购置金额" width="75px">
          </el-table-column>
          <el-table-column prop="purchaseTime" label="购置时间" width="110px">
          </el-table-column>
        </el-table>


        <p style="padding: 10px 0 10px;color: #d93c37;">变更内容 (显示为空即本次未变更部分)</p>
        <div style="border:1px #ccc solid;overflow:hidden;padding-bottom:10px;">

          <el-col :span="22" class="showDataDetail">
            <div class="tip">* 基本资料</div>
            <ul>
              <li>
                <label>资产编号:</label>
                <span>{{assetDetail.number}}</span>
              </li>
              <li class="w2">
                <label>资产名称:</label>
                <span>{{assetDetail.name}}</span>
              </li>
              <li class="w3">
                <label>分类:</label>
                <span>{{ getClassify(assetDetail) }}</span>
              </li>
              <li>
                <label>资产属性:</label>
                <span>{{ assetDetail.attribute?assetDetail.attribute.name:'' }}</span>
              </li>
              <li>
                <label>数量:</label>
                <span>{{assetDetail.amount}}</span>
              </li>
              <li>
                <label>购置金额(单价)(元):</label>
                <span>{{assetDetail.price}}</span>
              </li>
              <li>
                <label>购置时间:</label>
                <span>{{assetDetail.purchaseTime}}</span>
              </li>
              <li>
                <label>入库时间:</label>
                <span>{{assetDetail.storageTime}}</span>
              </li>

              <li>
                <label>入账时间:</label>
                <span>{{assetDetail.rzTime}}</span>
              </li>
              <li>
                <label>当前状态:</label>
                <span v-html="getStatus(assetDetail.status)"></span>
              </li>
              <li>
                <label>残值:</label>
                <span>{{ assetDetail.cz }}</span>
              </li>
              <li>
                <label>折旧年限:</label>
                <span>{{ assetDetail.zjnx }}</span>
              </li>

              <!-- <li v-if="assetDetail.panType=='0'">
                <label>盘亏情况说明:</label>
                <span>{{ assetDetail.panReason }}</span>
              </li> -->
            </ul>

            <div class="tip">* 规格型号属性</div>
            <ul>
              <li class="w2">
                <label>厂商:</label>
                <span>{{assetDetail.manufacturer}}</span>
              </li>
              <li>
                <label>规格型号:</label>
                <span>{{assetDetail.spec}}</span>
              </li>
              <li>
                <label>证书编号:</label>
                <span>{{assetDetail.certificateNum}}</span>
              </li>
              <li>
                <label>证件号码:</label>
                <span>{{assetDetail.zjhm}}</span>
              </li>
              <li>
                <label>面积:</label>
                <span>{{assetDetail.mj}}</span>
              </li>
              <li class="w2">
                <label>供应商:</label>
                <span>{{assetDetail.supplier?assetDetail.supplier.name:''}}</span>
              </li>
              <li>
                <label>出厂日期:</label>
                <span>{{assetDetail.ccTime}}</span>
              </li>
              <li>
                <label>截止保修期:</label>
                <span>{{assetDetail.bxTime}}</span>
              </li>
            </ul>

            <div class="tip">* 使用存放</div>
            <ul>
              <li>
                <label>所属部门:</label>
                <span>{{assetDetail.ownDept?assetDetail.ownDept.name:''}}</span>
              </li>
              <li class="w2">
                <label>存放地点:</label>
                <span>{{assetDetail.usePlace}}</span>
              </li>
              <li>
                <label>使用人:</label>
                <span>{{assetDetail.user ? assetDetail.user.name : ""}}</span>
              </li>
              <li>
                <label>责任人:</label>
                <span>{{assetDetail.zrUser ? assetDetail.zrUser.name : ""}}</span>
              </li>
              <li>
                <label>入库确认(财务):</label>
                <span>{{assetDetail.cwUser ? assetDetail.cwUser.name : ""}}
                </span>
              </li>
              <li class="remark w3">
                <label>备注:</label>
                <span>{{assetDetail.remark}}</span>
              </li>
            </ul>

            <div class="tip" v-if="assetDetail.attachments && assetDetail.attachments.length">* 附件</div>
            <div class="clear pi-attach-arr" style="margin-top:0;"
              v-if="assetDetail.attachments && assetDetail.attachments.length">
              <div class="appendix">
                <div class="item" v-for="item,i in assetDetail.attachments">
                  <i class="iconfont icon-link"></i>
                  <file-link :item="item"></file-link>
                  <a :href="item.fileUrl" style="margin-left:5px;" target="_blank">
                    <el-button size="mini">下载</el-button>
                  </a>
                </div>
              </div>
            </div>
          </el-col>

        </div>
      </div>
    </div>
  </section>
</template>


<script>
  import FileLink from '@/components/FileLink'
  import {
    mapState
  } from "vuex";

  export default {
    components: {
      FileLink,
    },
    computed: {
      ...mapState({
        assetChangeDetail: state => state.asset.assetChangeDetail,
      })
    },
    data() {
      return {
        attributeArr: ['自制', '采购', '租赁', '出租', '其他'],
        dataList: [],
        assetDetail: {}
      }
    },
    created() {},
    mounted() {
      // console.log(this.assetChangeDetail)

    },
    methods: {
      getStatus(status) {
        let statusName = ["闲置中", "使用中", "维修中", "正常报废", "非正常报废", "损毁", "出售", "其他", "盘盈", "盘亏"]
        return statusName[status]
      },
      // 获取单条资产详情
      getAssetDetail(id) {
        ajax.get('/asset/info/' + id, '', (res) => {
          this.assetDetail = res.vo
        })
      },
      // 组装分类
      getClassify(data) {
        let _str = ""
        if (data.mClassify) {
          _str += data.mClassify.name + " / "
        }
        if (data.dClassify) {
          _str += data.dClassify.name + " / "
        }
        if (data.parentClassify) {
          _str += data.parentClassify.name + " / "
        }
        if (data.classify) {
          _str += data.classify.name
        }
        return _str
      },
      // 隐藏表单
      hidePop() {
        this.$store.commit('set_assetChangeDetail', {
          status: false,
          data: {}
        })
      }
    },
    watch: {
      "assetChangeDetail"() {
        if (this.assetChangeDetail.data.changeAssets) {
          if (this.assetChangeDetail.data.changeAssets.length < 2) {
            // 单个资产
            this.getAssetDetail(this.assetChangeDetail.data.changeAssets[0].id)
          } else {
            this.assetDetail = this.assetChangeDetail
          }
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/assetChangeDetail.vue